import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Navbar, File, Nav, NavDropdown, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import BusinessIcon from '@material-ui/icons/Business';
import PeopleIcon from '@material-ui/icons/People';
import BookIcon from '@material-ui/icons/Book';
import ImageIcon from '@mui/icons-material/Image';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import GamepadIcon from '@mui/icons-material/Gamepad';
import StarIcon from '@material-ui/icons/Star';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import OrganizationFragment from '../fragments/OrganizationFragment';
import EmployeeFragment from '../fragments/EmployeeFragment';
import CourseFragment from '../fragments/CourseFragment';
import MaterialFragment from '../fragments/MaterialFragment';
import QuizzesFragment from '../fragments/QuizzesFragment';
import ReportFragment from '../fragments/ReportFragment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import InfographicsIcon from '@material-ui/icons/PhotoLibrary';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MastersFragment from '../fragments/MastersFragment';
import UserRatingScreen from './UserRatingScreen';
import RatingFragment from '../fragments/RatingFragment';
import InfographicsFragment from '../fragments/InfographicsFragment';
import NotificationsFragment from '../fragments/NotificationsFragment';
import UserFragment from '../fragments/UserFragment';
import PollIcon from '@mui/icons-material/Poll';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SurveyFragment from '../fragments/SurveyFragment';
import AnswerFragment from '../fragments/AnswerFragment';
import GeneralQuizFragment from '../fragments/GeneralQuizFragment';
import ThumbnailFragment from '../fragments/ThumbnailFragment';
import GeneralQuizMasterFragment from '../fragments/GeneralQuizMasterFragment';
import SurveyMasterFragment from '../fragments/SurveyMasterFragment';
import EmployeeManage from '../fragments/manage/EmployeeManage';
import CourseManage from '../fragments/manage/CourseManage';
import AnswerManage from '../fragments/manage/AnswerManage';
import RatingManage from '../fragments/manage/RatingManage';
import InfographicsManage from '../fragments/manage/InfographicsManage';
import NotificationsManage from '../fragments/manage/NotificationsManage';
import ReportManage from '../fragments/manage/ReportManage';
import GeneralQuizManage from '../fragments/manage/GeneralQuizManage';
import SurveyManage from '../fragments/manage/SurveyManage';


const ManageScreen = () => {

    const [currentScreen, setCurrentScreen] = useState(7);
    const [employees, setEmployees] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [materials, setMaterials] = useState([]);
    const [courses, setCourses] = useState([]);
    const [companies, setCompanies] = useState([]);
    const permissions = localStorage.getItem('permission');

    const handleMenuItemClick = (screenIndex) => {
        setCompanies('');
        setCourses('');
        setMaterials('');
        setCurrentScreen(screenIndex);
    };


    useEffect(() => {
        // fetchCompanies();
        fetchEmployees();
    }, []);

    // const fetchCompanies = async () => {
    //     const myHeaders = new Headers();
    //     myHeaders.append("Authorization", localStorage.getItem('token'));
    //     const requestOptions = {
    //         method: "GET",
    //         headers: myHeaders,
    //         redirect: "follow"
    //     };
    //     fetch("https://beiguru.co.in/admin/companies", requestOptions)
    //         .then((response) => {
    //             if (response.status == 401) {
    //                 localStorage.clear();
    //                 window.location.reload();
    //                 return [];
    //             } else {
    //                 return response.json()
    //             }
    //         })
    //         .then((result) => setCompanies(result))
    //         .catch((error) => console.error(error));
    // }

    const fetchEmployees = async () => {
        console.log('HERE');
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch("https://beiguru.co.in/admin/employees", requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setEmployees(result))
            .catch((error) => console.error(error));
    }


    return (
        <div style={{ height: '100vh' }}>
            <Navbar bg="white" expand="lg" elevation={5} style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                <Navbar.Brand href="#home" style={{ marginLeft: '20px' }}>
                    <img
                        src={require("../assets/coloredLogo.png")}
                        height="20"
                        className="d-inline-block align-center"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <div style={{ flex: 1 }} />
                <div style={{ height: '100%', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <h6 style={{ fontSize: '12px', fontFamily: 'Noto Sans' }}>Your company ID: {localStorage.getItem('companyID')}</h6>
                </div>
                <div style={{ marginRight: '20px' }} />
            </Navbar>
            <Grid container spacing={0} justifyContent="center" alignItems="center" style={{ height: '92%', fontFamily: "Noto Sans", }}>
                <Grid item xs={2} style={{ fontFamily: "Noto Sans", fontWeight: '500', backgroundColor: '#F6F6F6', height: '100%', justifyContent: 'start', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ height: '10px', }} />
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('dashboard') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 7 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(7);
                    }}>
                        <DashboardIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Dashboard</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('employee') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 1 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(1);
                    }}>
                        <PeopleIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Students</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('course') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 4 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(4);
                    }}>
                        <BookIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Courses</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('answers') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 13 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(13);
                    }}>
                        <ContactSupportIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Answer</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('rating') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 5 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(5);
                    }}>
                        <StarIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Rating</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('quiz') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 14 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(14);
                    }}>
                        <GamepadIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>General Quiz</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('survey') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 15 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(15);
                    }}>
                        <PollIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Survey</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('info') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 9 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(9);
                    }}>
                        <InfographicsIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Info</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('notification') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 10 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(10);
                    }}>
                        <NotificationsIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Notification</p>
                    </div> : null}
                    <div style={{ flex: 1, }} />
                    <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center' }} onClick={() => {
                        localStorage.clear();
                        window.location.reload();
                    }}>
                        <ExitToAppIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Logout</p>
                    </div>
                    <div style={{ height: '10px', }} />
                    {/* <p style={{ fontSize: '12px', fontWeight: '600', fontFamily: 'Noto Sans' }}>Uplifting Security Culture</p> */}
                    <p style={{ fontSize: '12px', fontWeight: '600', fontFamily: 'Noto Sans' }}>Service and Excellence</p>
                </Grid>
                {currentScreen == 1 ? <EmployeeManage /> : null}
                {currentScreen == 4 ? <CourseManage /> : null}
                {/* {currentScreen == 5 ? <QuizzesFragment company={companies} course={courses} material={materials} /> : null} */}
                {currentScreen == 5 ? <RatingManage /> : null}
                {currentScreen == 7 ? <ReportManage /> : null}
                {currentScreen == 9 ? <InfographicsManage /> : null}
                {currentScreen == 10 ? <NotificationsManage /> : null}
                {currentScreen == 14 ? <GeneralQuizManage /> : null}
                {currentScreen == 15 ? <SurveyManage /> : null}
                {currentScreen == 13 ? <AnswerManage /> : null}
            </Grid>
        </div >
    );
};

export default ManageScreen;